import React, { forwardRef, InputHTMLAttributes } from 'react';

import { mergeClassNames } from '@lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <input
        className={mergeClassNames(
          'inline-block w-full rounded-md shadow-sm text-sm h-10 placeholder:text-foreground/50 disabled:cursor-not-allowed disabled:opacity-50',
          className,
          error
            ? 'border-red-300 focus:border-red-400 focus:ring-red-500'
            : 'border-primary/20 focus:border-primary/50 focus:ring-primary',
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';
